import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { FloatLabel } from '../../Components';

interface IERdvComplementaryWidgetProps {
    dictComplementaryTitle: string;
    dictComplementaryDesc: string;
    dictCommentaryLabel: string;

    agency: string;
    service: string;
    justification: string;
    timing: string;

    comment: string;
    setComment: (comment: string) => void;
}

interface IERdvComplementaryWidgetState {
    comment: string;
}

export class ERdvComplementaryWidget extends Component<
    IERdvComplementaryWidgetProps,
    IERdvComplementaryWidgetState
> {
    constructor(props: IERdvComplementaryWidgetProps) {
        super(props);
        this.state = {
            comment: this.props.comment ? this.props.comment : (null as any),
        };
    }

    floatLabelActive(selectedValue: any): boolean {
        return selectedValue ? true : false;
    }

    handleChangeComment = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({ comment: event.target.value });
        this.props.setComment(event.target.value);
    };

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="offset-md-2 col-md-8">
                        <h2 className="h2">
                            {this.props.dictComplementaryTitle}
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-md-2 col-md-6 mt-3">
                        <p>{this.props.dictComplementaryDesc}</p>
                        <FloatLabel
                            active={this.floatLabelActive(this.state.comment)}
                            label={this.props.dictCommentaryLabel}
                            labelId={'name'}
                        >
                            <textarea
                                name="comment"
                                onChange={this.handleChangeComment}
                                value={this.props.comment}
                                style={{ resize: 'none' }}
                            />
                        </FloatLabel>
                    </div>
                    <div className="col-md-3 py-4 mt-3 mb-0 contact-theme-container">
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-place"></i>
                            </div>
                            <div className="col-10">{this.props.agency}</div>
                        </div>
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-user"></i>
                            </div>
                            <div className="col-10">
                                {this.props.service} <br />
                                {this.props.justification !== 'error' && (
                                    <span>{this.props.justification}</span>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-calendar"></i>
                            </div>
                            <div className="col-10">{this.props.timing}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(ERdvComplementaryWidget, 'erdv-complementary-widget');
